/* tslint:disable */
/* eslint-disable */
export enum SurveyType {
  ProcessIndustry = 1
}
